// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"108":"1fcf39c7","254":"f822bfad","432":"e121ed37","952":"b883f998"}[chunkId] + ".chunk.js";
};